import { X, MessageCircle, CheckCircle, AlertTriangle, AlertCircle } from 'lucide-react';
import { useToast } from '@/context/ToastContext';

/**
 * Toast notification component that displays at the top of the screen
 */
export function ToastContainer() {
  const { toasts, dismissToast } = useToast();

  if (toasts.length === 0) return null;

  return (
    <div className="fixed top-4 left-1/2 -translate-x-1/2 z-[100] flex flex-col gap-2 w-full max-w-sm px-4">
      {toasts.map((toast) => (
        <div
          key={toast.id}
          onClick={() => {
            if (toast.onClick) {
              toast.onClick();
              dismissToast(toast.id);
            }
          }}
          className={`
            flex items-start gap-3 p-4 rounded-xl shadow-lg border backdrop-blur-sm
            animate-slideDown cursor-pointer
            ${toast.type === 'success' ? 'bg-green-50/95 border-green-200 text-green-800' : ''}
            ${toast.type === 'error' ? 'bg-red-50/95 border-red-200 text-red-800' : ''}
            ${toast.type === 'warning' ? 'bg-yellow-50/95 border-yellow-200 text-yellow-800' : ''}
            ${toast.type === 'info' ? 'bg-[#fcf4fc]/95 border-[#e5bce5] text-[#63345e]' : ''}
          `}
        >
          {/* Icon */}
          <div className="shrink-0 mt-0.5">
            {toast.type === 'success' && <CheckCircle size={18} />}
            {toast.type === 'error' && <AlertCircle size={18} />}
            {toast.type === 'warning' && <AlertTriangle size={18} />}
            {toast.type === 'info' && <MessageCircle size={18} />}
          </div>

          {/* Message */}
          <p className="flex-1 text-sm font-medium">{toast.message}</p>

          {/* Dismiss button */}
          <button
            onClick={(e) => {
              e.stopPropagation();
              dismissToast(toast.id);
            }}
            className="shrink-0 p-1 rounded-full hover:bg-black/5 transition-colors"
          >
            <X size={14} />
          </button>
        </div>
      ))}

      {/* Animation styles */}
      <style>{`
        @keyframes slideDown {
          from {
            opacity: 0;
            transform: translateY(-20px);
          }
          to {
            opacity: 1;
            transform: translateY(0);
          }
        }
        .animate-slideDown {
          animation: slideDown 0.2s ease-out;
        }
      `}</style>
    </div>
  );
}
